import { render, staticRenderFns } from "./BoundaryItem.vue?vue&type=template&id=2a1093be&"
import script from "./BoundaryItem.vue?vue&type=script&lang=js&"
export * from "./BoundaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports